import { Button, Checkbox, TableCell, TableRow, Typography } from '@mui/material'
import { MoreVertical20Regular } from '@/components/Icon'
import threadRowStyles from '@/components/SecondaryLeftNavigation/components/ThreadListRow.module.scss'
import { getDocumentIconTone, getDocumentTypeIcon } from './documentItemMeta'
import DocumentStatusPill from './DocumentStatusPill.jsx'
import styles from './documentsPage.module.scss'
import { documentsPickerCheckboxSx } from './documentsPickerCheckboxSx.js'
import { documentsTableRowKebabSx } from './documentsTableRowKebabSx.js'

/**
 * @param {{
 *   item: import('./documentsDemoData').DocumentItem,
 *   isLast: boolean,
 *   menu: import('./useDocumentsTableMenu').ReturnType,
 *   pickerMode?: boolean,
 *   isSelected?: boolean,
 *   onToggleSelect?: (id: string) => void,
 * }} props
 */
export function DocumentsTableRow({
  item,
  isLast,
  menu,
  pickerMode = false,
  isSelected = false,
  onToggleSelect,
}) {
  const Icon = getDocumentTypeIcon(item.category)
  const tone = getDocumentIconTone(item.category)
  const menuOpenForRow = menu.openMenu && menu.menuDocumentId === item.id

  const handleRowToggle = () => onToggleSelect?.(item.id)

  return (
    <TableRow
      hover
      className={`${styles.tableBodyRow}${isLast ? ` ${styles.tableBodyRowLast}` : ''}${pickerMode ? ` ${styles.pickerRow}` : ''}`}
      onClick={pickerMode ? handleRowToggle : undefined}
    >
      {pickerMode ? (
        <TableCell className={styles.tdCheckbox} onClick={(event) => event.stopPropagation()}>
          <Checkbox
            size="small"
            checked={isSelected}
            onChange={handleRowToggle}
            inputProps={{ 'aria-label': `Select ${item.name}` }}
            sx={documentsPickerCheckboxSx}
          />
        </TableCell>
      ) : null}
      <TableCell className={styles.tdName}>
        <div className={styles.listNameCell}>
          <span className={`${styles.fileIconWrap} ${styles[`fileIconWrap_${tone}`]}`} aria-hidden>
            <Icon className={styles.fileIcon} />
          </span>
          <Typography variant="body2" color="text.primary" className={styles.docName}>
            {item.name}
          </Typography>
          <DocumentStatusPill status={item.status} />
        </div>
      </TableCell>
      <TableCell align="right" className={styles.tdModified}>
        <Typography variant="body2" color="text.secondary" className={styles.docMeta}>
          {item.updatedAt}
        </Typography>
      </TableCell>
      <TableCell align="right" className={styles.tdMeta}>
        <Typography variant="body2" color="text.secondary" className={styles.docMeta}>
          {item.sizeLabel}
        </Typography>
      </TableCell>
      {pickerMode ? null : (
        <TableCell align="right" className={styles.tdActions}>
          <Button
            type="button"
            variant="text"
            className={`${threadRowStyles.kebab} ${styles.rowKebab}`}
            sx={documentsTableRowKebabSx}
            aria-label={`Options for ${item.name}`}
            aria-expanded={menuOpenForRow}
            aria-haspopup="true"
            onClick={(event) => menu.handleOpenMenu(event, item.id)}
          >
            <MoreVertical20Regular className={threadRowStyles.kebabIcon} aria-hidden />
          </Button>
        </TableCell>
      )}
    </TableRow>
  )
}
